import { autobind } from 'core-decorators';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { setMetric } from '/@/store/product-datasheet/actions';
import { getMetric } from '/@/store/product-datasheet/selectors';
import { isMobile } from '/@/utils';
import Select from '/@/v3/components/forms/select';
import Title from '/@/v3/components/title';
import Product from './product';
import styles from './styles.module.css';

@connect(
    (state, props) => {
        return {
            metric: getMetric(state, props.metrics),
        };
    },
    (dispatch) =>
        bindActionCreators(
            {
                setMetric,
            },
            dispatch
        )
)
@autobind
export default class ProductList extends Component {
    render() {
        const { title, brand, metric, metrics, profiles, onProductChange } = this.props;
        return (
            <div className={styles.root}>
                <div className={styles.headline}>
                    {!isMobile() && <div className={styles.title}>{title}</div>}
                    <div className={styles.metrics}>
                        {this.props.metrics.length > 0 && (
                            <Fragment>
                                <Title size='md' color='light'>
                                    {_('Selecciona enfermedad para comparar entre materiales')}
                                </Title>
                                <Select
                                    appearance='outline'
                                    value={this.props.metric.id}
                                    options={metrics.map(({ id, name }) => ({ value: id, label: _(name) }))}
                                    onChange={this.props.setMetric}
                                    placeholder={_('Ver perfil defensivo')}
                                    clearable={false}
                                    color={settings.app.theme}
                                />
                            </Fragment>
                        )}
                    </div>
                </div>
                {isMobile() && <div className={styles.title}>{title}</div>}
                <div className={styles.products}>
                    {profiles.map((profile) => (
                        <div key={profile.id} className={styles.item}>
                            <Product
                                product={profile}
                                brand={brand}
                                metric={metric}
                                onProductChange={onProductChange}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
